/**
 * Enum defining the possible states a row can be in within a table.
 *
 * These states are used to control the visual appearance and behavior of rows
 * in tables and lists. Each state can trigger different styling and interactions.
 */
export enum RowStateType {
    /**
     * Indicates the row is disabled and cannot be interacted with
     */
    Disabled = "DISABLED",

    /**
     * Indicates the row has an error state
     */
    Error = "ERROR",

    /**
     * Indicates the row should be visually highlighted
     */
    Highlighted = "HIGHLIGHTED",

    /**
     * Indicates the row has a warning state
     */
    Warning = "WARNING",

    /**
     * Indicates the row has an associated tooltip
     */
    Tooltip = "TOOLTIP"
}
